module.exports = __webpack_public_path__ + "media/images/icons/truck-moving-12839b49f1b80fbb4bac6fddbac31070.svg";